/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/
import React from 'react';

import { FormContainer } from 'components/index';
import {
  Label,
  Icon,
  FormSectionGlobal as FormSection
} from '@fitinsur/components';

import { GeneralSection } from '../../general/index';

function RenderSection({
  formikProps,
  formikRef,
  idProduct,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  hierarchyGroup = [],
  setHierarchyGroup
}) {
  const handleArrow = (arrowDirection, index) => {
    const newHierarchyGroup = [...hierarchyGroup];
    if (arrowDirection === 'up' && index > 0) {
      [newHierarchyGroup[index - 1], newHierarchyGroup[index]] = [newHierarchyGroup[index], newHierarchyGroup[index - 1]];

    } else if (arrowDirection === 'down' && index < hierarchyGroup.length - 1) {
      [newHierarchyGroup[index + 1], newHierarchyGroup[index]] = [newHierarchyGroup[index], newHierarchyGroup[index + 1]];
    }
    setHierarchyGroup(newHierarchyGroup);
  };

  return (
    <FormContainer show={true} /* collapsedAtStart */ title="Hierarchy">
      <div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
        <div style={{ display: "flex" }}>
          <Label style={{ width: "140px", whiteSpace: "nowrap", textAlign: "center" }}>Display Order:</Label>
          <Label style={{ width: "200px", whiteSpace: "nowrap" }}>Legal Entity:</Label>
        </div>
        <div>
          {hierarchyGroup.map((questions, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', width: '100%', paddingRight: "5px" }}>
              <GeneralSection.components.renderDisplayOrder 
                index={index}
                groupLength={hierarchyGroup.length}
                handleArrow={handleArrow}
              />
              <div style={{ flex: 1 }}>
                <FormSection
                  sectionName="HIERARCHY"
                  errors={formikProps.errors}
                  questionnaire={questions}
                  setQuestionnaire={(questionnaire) => setHierarchyGroup(hierarchyGroup.map((group, i) => i === index ? questionnaire : group))}
                  values={formikProps.values}
                  setFieldValue={formikProps.setFieldValue}
                  setFieldError={formikProps.setFieldError}
                  formikRef={formikRef}
                  idProduct={idProduct}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </FormContainer>
  );
}

const components = {
  RenderSection
};

export { components };